import React from "react";
import { Typography, useMediaQuery, TypographyProps } from "@mui/material";

const Title1 = (props: TypographyProps) => {
  const breakPoints = useMediaQuery((theme: any) => theme.breakpoints.up("sm"));

  return (
    <Typography
      variant={breakPoints ? "h3" : "h4"}
      gutterBottom
      fontWeight={breakPoints ? 700 : 300}
      {...props}
    >
      {props.children}
    </Typography>
  );
};

export default Title1;
